module.exports = __webpack_public_path__ + "assets/img/1_1464_big.ee9e9bf3.jpg";